import { hyphenate } from "hyphen/nl";

document.addEventListener("DOMContentLoaded", () => {
    const titles = document.querySelectorAll<HTMLElement>('h1, h2, h3, h4, h5, h6, .hyphenate');

    titles.forEach(async (title) => {
        const originalText = title.textContent?.trim();

        if (!originalText) return;

        const words = originalText.split(' ');

        const processedWords = await Promise.all(
            words.map(async (word) => {
                if (word.length > 12) {
                    return await hyphenate(word);
                }
                return word;
            })
        );

        const improvedText = processedWords.join(' ');

        title.innerHTML = improvedText.replace(/\u00AD/g, '\u00AD&shy;');
        title.textContent = improvedText;
        title.style.hyphens = 'manual';
    });
});